import { render, staticRenderFns } from "./PgRequestControl.vue?vue&type=template&id=3c7d9ae3&"
import script from "./PgRequestControl.vue?vue&type=script&lang=js&"
export * from "./PgRequestControl.vue?vue&type=script&lang=js&"
import style0 from "./PgRequestControl.vue?vue&type=style&index=0&id=3c7d9ae3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports